import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import MangaCard from "@/components/base/MangaCard";

export default function FeaturedManga() {
  const featured = mangaList.filter((m) => m.featured).slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">编辑精选，品质保证，每一部都值得一看</p>
        </div>
        <Link
          to="/category/hanman"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
        {featured.map((manga) => (
          <MangaCard key={manga.id} {...manga} />
        ))}
      </div>
    </section>
  );
}